import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import HeaderBig from './Header-big';
import HeaderSmall from './Header-small';
import {isExperiment} from '../config';

class Header extends React.Component {

  render() {
    if (isExperiment('appMarketNoHeader', this.props.experiments) || this.props.market === 'standalone') {
      return <HeaderSmall location={this.props.location}/>;
    } else {
      return <HeaderBig location={this.props.location} isCategory={this.props.isCategory}/>;
    }
  }
}

Header.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  isCategory: PropTypes.bool,
  market: PropTypes.string,
  experiments: PropTypes.object
};

function mapStateToProps(state, props) {
  return {
    isCategory: props.route.isCategory,
    market: state.mode.market,
    experiments: state.mode.experiments
  };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./containers/Header.js